// Vue 2 plugin registrations + global filters from the original app.js.
// Kept verbatim so legacy components that call `this.$modal.show(...)` /
// `this.$notify(...)` / `Vue.filter('formatDate')` keep working.

import Vue from 'vue'
import VModal from 'vue-js-modal'
import Datepicker from 'vuejs-datepicker'
import VueHtmlToPaper from 'vue-html-to-paper'
import Notifications from 'vue-notification'
import WebCam from 'vue-web-cam'
import VueSimpleAlert from 'vue-simple-alert'
import 'sweetalert2/dist/sweetalert2.min.css'
import moment from 'moment'
import axios from 'axios'
import { Capacitor } from '@capacitor/core'
import { Printer } from '@bcyesil/capacitor-plugin-printer'
import { PAGE_MARGIN } from '@/utils/printHtml'

Vue.prototype.$http = axios

const AudioRecorder = window.VueAudioRecorder

Vue.component('datepicker', Datepicker)

Vue.use(VModal, { dialog: true })
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })
Vue.use(Notifications)
Vue.use(WebCam)
Vue.use(AudioRecorder)
Vue.use(VueSimpleAlert)
Vue.use(VueHtmlToPaper)

// vue-html-to-paper prints via window.open()+window.print(), which are no-ops
// inside the native WebViews. On Android/iOS, route $htmlToPaper through the
// native print dialog instead. We inline the page's <style> blocks (scoped
// component styles) so the printout keeps as much formatting as possible.
if (Capacitor.isNativePlatform()) {
  Vue.prototype.$htmlToPaper = function (elementId, _options, cb) {
    const el = document.getElementById(elementId)
    const body = el ? el.innerHTML : ''
    const styles = Array.from(document.querySelectorAll('style'))
      .map((n) => n.outerHTML)
      .join('')
    const html =
      '<!doctype html><html><head><meta charset="utf-8">' +
      '<meta name="viewport" content="width=device-width, initial-scale=1.0">' +
      '<base href="' + window.location.origin + '/">' +
      // Same paper margin as every other print path in the app.
      '<style>@page{margin:' + PAGE_MARGIN + '}</style>' +
      styles +
      '</head><body>' +
      body +
      '</body></html>'
    Printer.print({ content: html, name: document.title || 'Document' })
      .then(() => { if (typeof cb === 'function') cb() })
      // eslint-disable-next-line no-console
      .catch((e) => console.error('Native print failed', e))
    return Promise.resolve()
  }
}

Vue.filter('formatDate', (value) => {
  if (value) return moment(String(value)).format('DD-MM-YYYY')
  return ''
})

Vue.filter('formatTime', (value) => {
  if (value) return moment(String(value)).format('HH:mm')
  return ''
})
